export default "__VITE_PUBLIC_ASSET__4c8607f5__"